export default "__VITE_ASSET__72ba2936__"